<svelte:options runes={true} />

<script lang="ts">
  import IconLoader from "~icons/dusk/loader";
  import Button from "~/components/ui/Button/Button.svelte";

  interface Props {
    loading?: boolean;
    error?: boolean;
    onClick?: () => void;
  }

  let { loading = false, error = false, onClick }: Props = $props();
</script>

{#if error}
  <p class="da-load-more__error">Failed to load more products</p>
{:else}
  <Button size="xl" variant="primary" disabled={loading} onclick={onClick} class="da-load-more">
    {loading ? "Loading..." : "Load more..."}
    {#snippet trailingIcon()}
      {#if loading}
        <IconLoader aria-hidden="true" width="20" height="20" class="da-load-more__spinner" />
      {/if}
    {/snippet}
  </Button>
{/if}

<style>
  @layer aurora {
    :global(.da-load-more) {
      width: 100%;
    }

    .da-load-more__error {
      text-align: center;
      font-family: var(--da-font-family-primary);
      font-size: var(--da-font-size-sm);
      color: var(--da-color-charcoal-400);
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    :global(.da-load-more__spinner) {
      animation: spin 1s linear infinite;
    }
  }
</style>
